<template>
    <div class="player" style="width: 100%;">
        <!--<div class="container" STYLE="min-height: 200px !important;">
            <video :src="lesson_info.video_url" type="video/mp4" class="audio-slideshow"/>
        </div>-->
        <video-player ref="videoPlayer" class="video-player vjs-custom-skin audio-slideshow"
                      :playsinline="true"
                      :options="playerOptions"/>
        <!--@play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"-->

    </div>
</template>

<script type="text/javascript">

    import {mapState, mapActions} from 'vuex'
    import learningApi from '@/api/learning/learning.js'

    export default {
        computed: {
            ...mapState({
                lesson_info: state => state.learning.lesson_info
            }),
        },
        methods: {

            ...mapActions({
                get_and_change_lesson_info: 'learning/get_and_change_lesson_info',
            }),
        },
        watch: {
            lesson_info: function () {
                if (this.lesson_info.video_url) {
                    this.$nextTick(function () {
                        this.$refs.videoPlayer.player.currentTime(this.lesson_info.lesson_progress.progress)
                        this.$refs.videoPlayer.player.src(this.lesson_info.video_url);
                        // $(".vjs-progress-holder").click(function () {
                        //     console.log('sasd22')
                        // })
                        // $(".vjs-progress-control").click(function () {
                        //     console.log('sasd')
                        // })
                    })
                } else {
                    this.$nextTick(function () {

                    })
                }

            }
        },
        mounted() {
            let courseId = this.$route.params.id;
            let lessonId = this.$route.query.id;
            let args = {'courseId': courseId, 'lessonId': lessonId};
            this.get_and_change_lesson_info(args);
            var that = this
            var interval = setInterval(function () {
                // console.log(that.$refs.videoPlayer.player.cache_.currentTime)
                // var t = $('.vjs-current-time-display')[0].innerText.split(':');
                var curTime = that.$refs.videoPlayer.player.cache_.currentTime
                var routeParams = window.location.search;
                learningApi.set_lesson_progress(routeParams, curTime).then(function (res) {
                    console.log(res.data)
                });
            }, 60000);

        },
        data() {
            return {
                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: "https://px.ujoy.cn/ZiLiaoFiles/tmp/2/black15.mp4",
                    }],
                    poster: "../../static/images/test.jpg", //你的封面地址
                    // width: document.documentElement.clientWidth, //播放器宽度
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                },
            }
        },
    }


</script>
<style type="text/css" scoped>
    @import '../../../assets/css/jquery.audioslideshow.css';

    .player {
        float: left;
    }

    .container {
        padding: 0;
    }

    .video-js .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
    }

    .marker span img {
        display: none !important;
    }

    .audio-slideshow {
        width: 100% !important;
    }

    @media screen and (max-width: 1000px) {
        .container > header h1 {
            font-size: 12px !important;
            font-weight: bold;
            line-height: 12px !important;
        }

        .container {
            min-height: 220px;
        }

        /*已经在控件中设置了自动高度*/
        /*.audio-slideshow {*/
        /*    height: 210px !important;*/
        /*}*/
    }

    .tab_audios_div {
        display: block;
    }

    /* 左右切换按钮 */


    .tab_audios_a {
        position: absolute;
        display: block;
        height: 80px;
        width: 80px;
        top: 48%;
        bottom: 50%;
        border-radius: 40px;
        background: black;
        opacity: .3;
        text-align: center;
        line-height: 74px;
        z-index: 5;
    }

    .tab_audios_a:hover {
        opacity: .3;
    }

    .tab_audios_button {
        height: 60px;
        width: 40px;
        font-size: 40px;
        color: #fff;
        /*text-align: center;*/
    }

    .tab_audios_a_left {
        left: 5%;
        transform: translate(0, -50%);
    }

    .tab_audios_a_play {
        left: 45%;
        opacity: .8;
        transform: translate(0, -50%);
    }

    .tab_audios_button_left:after {
        content: "<";
    }

    .tab_audios_button_play:after {
        content: "▷";
        margin-left: 4px;
        font-size: 45px;
    }

    .tab_audios_a_right {
        right: 5%;
        transform: translate(0, -50%);
    }

    .tab_audios_button_right:before {
        content: ">";
    }

    @media screen and (max-width: 1000px) {
        .tab_audios_a {
            height: 40px;
            width: 40px;
            top: 48%;
            line-height: 1.4;
        }

        .tab_audios_button {
            font-size: 25px;
        }

        .tab_audios_button_play:after {
            font-size: 30px !important;
        }
    }
</style>